import { deleteProfileImgs, getAccount, postProfileImgs } from '#api/accounts';
import { queryKeyFactory } from '#api/queryKeyFactory';
import { useToast } from '#providers/ToastProvider';
import { useUserInfo } from '#providers/UserInfo';
import { Profile } from '#types/account';
import { useQueryClient } from '@tanstack/react-query';

const useUploadProfile = ({
  images,
  maxCount
}: {
  images: Profile[];
  maxCount: number;
}) => {
  const { userInfo, setUserInfo } = useUserInfo();
  const queryClient = useQueryClient();
  const { showToast } = useToast();

  const handlePostImages = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = e.target.files;

    if (!selectedFiles) return;
    const newFiles = Array.from(selectedFiles);

    // false면 유효하지 않음
    const isValidFormats = newFiles.some(
      value => !value.type.includes('video')
    );

    //  이미지 양식만 보내도록 분기 처리
    if (!isValidFormats) {
      showToast({
        message: `이미지 양식이 아닌 파일이 있습니다. 다시 확인해주세요.`,
        type: 'fail'
      });
      return;
    }

    if (images.length + newFiles.length > maxCount) {
      showToast({
        message: `이미지는 최대 ${maxCount}장까지 등록 가능합니다.`,
        type: 'fail'
      });
      return;
    }

    const formData = new FormData();

    newFiles.forEach(image => {
      formData.append('profile', image);
    });

    postProfileImgs({ profileImgs: formData })
      .then(() => {
        showToast({ message: '이미지 등록에 성공하였습니다.' });
        getAccount(userInfo?.id ?? '').then(res => {
          const updatedProfileImgs = res.profile;
          updatedProfileImgs &&
            userInfo &&
            setUserInfo({ ...userInfo, profile: updatedProfileImgs });
        });
        queryClient.invalidateQueries({
          queryKey: queryKeyFactory.GET_MY_ACCOUNT()
        });
      })
      .catch(() =>
        showToast({ type: 'fail', message: '이미지 등록에 실패하였습니다.' })
      );
  };
  const handleDeleteImage = async (imgId: string) => {
    deleteProfileImgs({ profileIds: [imgId] })
      .then(() => {
        showToast({ message: '이미지 삭제에 성공하였습니다.' });
        getAccount(userInfo?.id ?? '').then(res => {
          const updatedProfileImgs = res.profile;
          updatedProfileImgs &&
            userInfo &&
            setUserInfo({ ...userInfo, profile: updatedProfileImgs });
        });
        queryClient.invalidateQueries({
          queryKey: queryKeyFactory.GET_MY_ACCOUNT()
        });
      })
      .catch(() =>
        showToast({ type: 'fail', message: '이미지 삭제에 실패하였습니다.' })
      );
  };

  return {
    handlePostImages,
    handleDeleteImage
  };
};

export default useUploadProfile;
